"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.create = void 0;
var tslib_1 = require("tslib");
var RuntimeDataSourceEngineFactory_1 = tslib_1.__importDefault(require("./RuntimeDataSourceEngineFactory"));
exports.create = RuntimeDataSourceEngineFactory_1.default;
